import { getMentionsPlugin } from 'hubspot-prosemirror/prosemirror/plugins/MentionsPlugin';
import { AT_MENTION } from 'hubspot-prosemirror/prosemirror/utils/mentionsUtil';
import { getMatchResults } from 'hubspot-prosemirror/prosemirror/ProsemirrorUtils';
import PortalIdParser from 'PortalIdParser';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { getOutOfOfficeAtMentionLabel } from 'routing-ui/working-hours/utils/outOfOfficeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
function OwnersNotFound({
  text
}) {
  return /*#__PURE__*/_jsx("div", {
    className: "suggestion-item",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "draftPlugins.tokenPlugin.atMentions.resultsZeroState.notFound",
      options: {
        search: text,
        uri: `/settings/${PortalIdParser.get()}/users/new`
      }
    })
  });
}
OwnersNotFound.displayName = 'OwnersNotFound';
export const configureMentionsPlugin = ({
  owners
}) => {
  const transformedOwners = owners.map(owner => {
    const outOfOfficeLabel = getOutOfOfficeAtMentionLabel(owner.outOfOfficeHours);
    const text = outOfOfficeLabel ? `${owner.text} ${outOfOfficeLabel}` : owner.text;
    return {
      searchText: `${text} ${owner.value}`,
      text,
      id: owner.id
    };
  });
  const atMentionPlugin = getMentionsPlugin({
    getSuggestions: (text, done) => {
      done(getMatchResults(text, transformedOwners));
    },
    type: AT_MENTION,
    NotFoundComponent: OwnersNotFound
  });
  return atMentionPlugin;
};